import {
  IReplay,
  IReplayAudioLayer,
  IReplayGroupLayer,
  IReplayImageLayer,
  IReplayLayer,
  IReplayShapeLayer,
  IReplayTextLayer,
  IReplayVideoLayer,
} from '../types';

import {
  isReplayAudioLayer,
  isReplayGroupLayer,
  isReplayImageLayer,
  isReplayShapeLayer,
  isReplayTextLayer,
  isReplayVideoLayer,
} from './predicates';

const findReplayLayers = (replay: IReplay, layerIds: IReplayLayer['uuid'][]): IReplayLayer[] =>
  layerIds.map(layerId => replay.context.layers[layerId]);

const findReplayGroups = (replay: IReplay): IReplayGroupLayer[] =>
  Object.values(replay.context.layers).filter(isReplayGroupLayer);

const findReplayTexts = (replay: IReplay): IReplayTextLayer[] =>
  Object.values(replay.context.layers).filter(isReplayTextLayer);

const findReplayImages = (replay: IReplay): IReplayImageLayer[] =>
  Object.values(replay.context.layers).filter(isReplayImageLayer);

const findReplayShapes = (replay: IReplay): IReplayShapeLayer[] =>
  Object.values(replay.context.layers).filter(isReplayShapeLayer);

const findReplayAudios = (replay: IReplay): IReplayAudioLayer[] =>
  Object.values(replay.context.layers).filter(isReplayAudioLayer);

const findReplayVideos = (replay: IReplay): IReplayVideoLayer[] =>
  Object.values(replay.context.layers).filter(isReplayVideoLayer);

const findReplayLayerParent = (replay: IReplay, layerId: IReplayLayer['uuid']): IReplayGroupLayer =>
  Object.values(replay.context.layers).find(
    layer => isReplayGroupLayer(layer) && layer.props.children.value.includes(layerId),
  ) as IReplayGroupLayer;

const findReplayLayerChildren = (
  replay: IReplay,
  layerId: IReplayLayer['uuid'],
): IReplayLayer[] => {
  const groupLayer = replay.context.layers[layerId] as IReplayGroupLayer;
  if (!isReplayGroupLayer(groupLayer)) {
    throw new Error('Layer is not a group');
  }

  return groupLayer.props.children.value.map(childLayerId => replay.context.layers[childLayerId]);
};

export {
  findReplayTexts,
  findReplayLayers,
  findReplayGroups,
  findReplayImages,
  findReplayShapes,
  findReplayAudios,
  findReplayVideos,
  findReplayLayerParent,
  findReplayLayerChildren,
};
